import { createAction, handleActions } from "redux-actions";

import { MakeModelInfo as MakeModelInfoApi } from "../../services/api";
import { MakeModelInfoDto, rootReducerInterface } from "../../typings/interfaces";

const MAKE_MODEL_INFO_GET = "MAKE_MODEL_INFO_GET";
const MAKE_MODEL_INFO_CLEAR = "MAKE_MODEL_INFO_CLEAR";

export interface MakeModelInfoStateI {
  data: MakeModelInfoDto | null;
  isLoading: boolean;
  notFound: boolean;
}

const initialState: MakeModelInfoStateI = {
  data: null,
  isLoading: false,
  notFound: false
};

export const clearMakeModelInfo = createAction(MAKE_MODEL_INFO_CLEAR);

// The page is public — for anonymous users a 401/missing-record response must
// not trigger the default unauthorized redirect to login. Pass a silent error
// handler so failures collapse to notFound and the InvalidPage is rendered.
const silentGetError = (response: any) => {
  throw response;
};

export const getMakeModelInfo = createAction(
  MAKE_MODEL_INFO_GET,
  async (makeId: string, modelId: string) => {
    if (!makeId || !modelId) {
      return { data: null, notFound: true };
    }
    try {
      const response = await MakeModelInfoApi.getByMakeModel(makeId, modelId, silentGetError);
      if (!response || !response.id) {
        return { data: null, notFound: true };
      }
      return { data: response, notFound: false };
    } catch (e) {
      return { data: null, notFound: true };
    }
  }
);

export const selectMakeModelInfo = (state: rootReducerInterface) =>
  state.makeModelInfo.data;

export const selectMakeModelInfoLoading = (state: rootReducerInterface) =>
  state.makeModelInfo.isLoading;

export const selectMakeModelInfoNotFound = (state: rootReducerInterface) =>
  state.makeModelInfo.notFound;

export default handleActions(
  {
    [MAKE_MODEL_INFO_GET]: (state: MakeModelInfoStateI, { payload }) => ({
      ...state,
      data: payload ? payload.data : null,
      notFound: payload ? payload.notFound : true,
      isLoading: false
    }),
    [MAKE_MODEL_INFO_CLEAR]: () => initialState
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/MakeModelInfo/makeModelInfo.ducks.ts